import { render } from "./SideBySide.vue?vue&type=template&id=4076ee2a&scoped=true"
import script from "./SideBySide.vue?vue&type=script&lang=js"
export * from "./SideBySide.vue?vue&type=script&lang=js"

import "./SideBySide.vue?vue&type=style&index=0&id=4076ee2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4076ee2a"

export default script